import { render, staticRenderFns } from "./SalariePrintReport.vue?vue&type=template&id=4bfe16d7&scoped=true"
import script from "./SalariePrintReport.vue?vue&type=script&lang=js"
export * from "./SalariePrintReport.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintReport.vue?vue&type=style&index=0&id=4bfe16d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe16d7",
  null
  
)

export default component.exports